module.exports = __webpack_public_path__ + "static/media/healthBlue.49f81734.svg";